import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import { createPinia } from 'pinia'
import router from './router'
import { createHead } from '@vueuse/head'   // ✅ import head manager

const app = createApp(App)
const pinia = createPinia()
const head = createHead()                   // ✅ create head manager instance

app.use(router)
app.use(pinia)
app.use(head)                               // ✅ register head
app.mount('#app')
